import { createSlice } from "@reduxjs/toolkit";
import { FilterStateUser } from "./types";

const INITIAL_STATE: FilterStateUser = {
  filters: {
    search: "",
    meta: {
      page: 1,
    },
  },
};

const userFilterSlice = createSlice({
  name: "userFilter",
  initialState: INITIAL_STATE,
  reducers: {
    setUserFilter(state, action) {
      const { key } = action.payload;
      state.filters[key] = action.payload.value;
      // Qualquer mudanca de filtro (que nao seja a propria paginacao) volta p/ pagina 1,
      // senao o usuario fica preso numa pagina vazia ao filtrar estando na pagina 2+.
      if (key !== "meta") {
        state.filters.meta = { ...state.filters.meta, page: 1 };
      }
    },
  },
});

export const { setUserFilter } = userFilterSlice.actions;
export default userFilterSlice.reducer;
